export function normalizeApiError(error) {
  const response = error?.response;
  const payload = response?.data || error?.data || {};
  const nestedError = payload.error || {};

  return {
    code: payload.code || nestedError.code || null,
    message:
      payload.message ||
      nestedError.message ||
      error?.message ||
      "Something went wrong. Please try again.",
    status: response?.status || error?.status || null,
    errors: payload.errors || nestedError.errors || [],
  };
}
